import { Component, ElementRef, HostBinding, Input, Optional, Renderer2, Self, ViewChild } from "@angular/core";
import { NgControl } from "@angular/forms";

import { SpsFormControlComponent } from "../forms/sps-form-control.abstract.component";

@Component({
    selector: "sps-radio-button",
    templateUrl: "./sps-radio-button.component.html",
    providers: [{ provide: SpsFormControlComponent, useExisting: SpsRadioButtonComponent }]
})
export class SpsRadioButtonComponent<T> extends SpsFormControlComponent<T> {
    static readonly displayName = "sps-radio-button";
    static readonly props = {
        value: "T",
        label: "string",
    };

    @Input() value: T;
    @Input() label: string;
    @Input() formControlName: string;

    @HostBinding("class.sps-custom-control") readonly spsCustomControlClass = true;
    @HostBinding("class.sps-custom-radio") readonly spsCustomRadioClass = true;

    @HostBinding("class.sps-custom-control--no-label") get noLabelClass() {
        return !this.label;
    }

    @HostBinding("class.sps-input--error")
    get inputErrorClass() {
        return this.isInErrorState;
    }

    @ViewChild("radioInput", { static: false }) inputElement: ElementRef;

    get isChecked(): boolean {
        return this._control && this._control.value === this.value;
    }

    constructor(
        el: ElementRef,
        renderer: Renderer2,
        @Self()
        @Optional()
        ngControl: NgControl
    ) {
        super(el, renderer, ngControl);
    }

    _updateControl() {
        this._control.setValue(this.value);
        this.inputElement.nativeElement.focus();
    }
}
